import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { CATEGORIES_MENU_FEATURE, CategoriesMenuState, StateWithCategoriesMenu } from '../categories-menu-state';

export const getFeatureState: MemoizedSelector<StateWithCategoriesMenu, CategoriesMenuState> =
  createFeatureSelector<CategoriesMenuState>(CATEGORIES_MENU_FEATURE);
